<template>
  <div class="login-page">
    <div class="input-box">
      <div class="box-title">账户登录</div>
      <el-input class="row input" v-model="phone" placeholder="请输入手机号"></el-input>
      <div class="row">
        <el-input class="short-input" v-model="pictureVerificationCode" placeholder="请输入图片验证码"></el-input>
        <img
          class="verification-image"
          title="点击更换"
          :src="verificationImageUrl"
          @click="refreshVerificationImageUrl"
        />
      </div>
      <div class="row">
        <el-input class="short-input" v-model="phoneVerificationCode" placeholder="请输入短信验证码"></el-input>
        <el-button
          class="short-btn"
          type="primary"
          @click="sendMessageCode"
          :disabled="!captchaBtnVisible"
        >{{countdownPoint}}</el-button>
      </div>
      <!--<div class="row">-->
      <!--<el-checkbox class="check-box" v-model="savePassword">记住密码</el-checkbox>-->
      <!--<el-button class="text-btn" type="text">忘记密码</el-button>-->
      <!--</div>-->
      <el-button class="full-width" type="primary" @click="onLoginBtnClick">登录</el-button>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "loginPage",
  data() {
    return {
      phone: "",
      pictureVerificationCode: "",
      phoneVerificationCode: "",
      captchaBtnVisible: true,
      countdown: 60,
      verificationImageUrl: "",
      tempToken: "",
      countdownPoint: "获取验证码"
    };
  },
  mounted() {
    this.checkLogin();
    this.securityImageCode();
  },
  methods: {
    securityImageCode() {
      let self = this;
      this.$http
        .get("/imageValidateCode")
        .then(function(response) {
          let data = response.data;
          if (!data) {
            self.$message({
              type: "error",
              message: "获取图片验证码失败!",
              center: true
            });
            return;
          }
          self.verificationImageUrl = data.mdata.image;
          self.tempToken = data.mdata.token;
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    sendMessageCode() {
      if (!this.phone) {
        this.$message({
          type: "error",
          message: "请填写您的手机号码!",
          center: true
        });
        return;
      }
      if (this.phone.length != 11) {
        this.$message({
          type: "error",
          message: "手机号码格式不正确!",
          center: true
        });
        return;
      }
      if (!this.pictureVerificationCode) {
        this.$message({
          type: "error",
          message: "请填写图片验证码!",
          center: true
        });
        return;
      }
      let params = {
        phone: this.phone,
        imageValidateCode: this.pictureVerificationCode
      };
      let self = this;
      this.$http
        .get("/sendSmsValidateCode?" + this.$qs.stringify(params), {
          headers: { Token: this.tempToken }
        })
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.verificationCountDown();
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    verificationCountDown() {
      this.captchaBtnVisible = false;
      let self = this;
      function countDown() {
        if (self.countdown == 0) {
          self.captchaBtnVisible = true;
          self.countdown = 60;
          self.countdownPoint = "重新发送";
          self.refreshVerificationImageUrl();
        } else {
          self.countdownPoint = "重新发送(" + self.countdown + ")";
          self.countdown--;
          self.captchaTimer = setTimeout(countDown, 1000);
        }
      }
      countDown();
    },
    refreshVerificationImageUrl() {
      this.securityImageCode();
    },
    onLoginBtnClick() {
      this.userLoginByPhone();
    },
    userLoginByPhone() {
      if (!this.phoneVerificationCode) {
        this.$message({
          type: "error",
          message: "请输入短信验证码",
          center: true
        });
        return;
      }
      let self = this;
      let params = {
        validateCode: this.phoneVerificationCode,
        appType: 1,
        loginType: 0,
        authCode: this.phone
      };
      this.$http
        .post("/login", this.$qs.stringify(params), {
          headers: { Token: this.tempToken }
        })
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.refreshVerificationImageUrl();
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          Utils.setLocalStorage("token", res.mdata.token);
          self.checkLogin();
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    checkLogin() {
      let self = this;
      console.log(Utils.getLocalStorage("token"));
      this.$http
        .get("/checkLogin", {
          headers: { token: Utils.getLocalStorage("token") }
        })
        .then(function(response) {
          let res = response.data;
          if (res.mdata.login) {
            //self.$router.push('/managePage/workforceMgmt');
            self.getMenuList();
            self.getUserInfo();
          }
        });
    },
    getMenuList() {
      let self = this;
      this.$http
        .get("/admin/application/menu/getAvailable?platformType=3", {
          headers: { token: Utils.getLocalStorage("token") }
        })
        .then(function(response) {
          let res = response.data;
          let menus = res.ldata;
          if (menus.length == 0) {
            self.$message({
              type: "warning",
              message: "无可用功能",
              center: true
            });
          } else {
            if (menus[0].subMenuList.length > 0) {
              self.$router.push(menus[0].subMenuList[0].path);
            } else {
              self.$message({
                type: "warning",
                message: "无可用功能",
                center: true
              });
            }
          }
        })
        .catch(function(response) {
          console.log(response);
        });
    },
    getUserInfo() {
      let self = this;
      this.$http
        .get("/getUserInfo", {
          headers: { token: Utils.getLocalStorage("token") }
        })
        .then(function(response) {
          let res = response.data;
          if (res.mdata.userInfo) {
            self.$store.dispatch("SET_CURRENT_USER", res.mdata.userInfo.name || res.mdata.userInfo.mobilePhone);
          }
        })
        .catch(function(response) {
          console.log(response);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  .image {
    display: inline-block;
    margin-left: 200px;
    width: 45%;
  }
  .input-box {
    position: absolute;
    top: 80px;
    right: 250px;
    width: 333px;
    height: 442px;
    box-shadow: 0px 3px 15px 0px rgba(170, 170, 170, 0.32);
    border-radius: 7px;
    padding: 22px;
    box-sizing: border-box;
    margin-bottom: 25px;
    .box-title {
      font-size: 19px;
      color: #000;
      padding-bottom: 25px;
    }
    .row {
      height: 32px;
      margin-bottom: 15px;
      font-size: 14px;
      line-height: 16px;
      .short-input {
        width: 180px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .verification-image {
        width: 92px;
        height: 32px;
        vertical-align: middle;
      }
      .short-btn {
        vertical-align: middle;
        width: 94px;
      }
      .check-box {
        padding: 5px 0;
      }
      .text-btn {
        float: right;
      }
    }
  }
  .full-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue